import { checkoutShippingAddressesStyles as styles } from "@solveindustrial/Overrides/Widgets/CheckoutShipping/CheckoutShippingAddresses";
import { css } from "styled-components";

const order = [
    {
        selector: "customerAddressForm_companyName-label",
        order: 1,
    },
    {
        selector: "customerAddressForm_country-label",
        order: 2,
    },
    {
        selector: "customerAddressForm_address1-label",
        order: 3,
    },
    {
        selector: "customerAddressForm_address2-label",
        order: 4,
    },
    {
        selector: "customerAddressForm_city-label",
        order: 5,
    },
    {
        selector: "customerAddressForm_state-label",
        order: 6,
    },
    {
        selector: "customerAddressForm_postalCode-label",
        order: 7,
    },
    {
        selector: "customerAddressForm_phone-label",
        order: 8,
    },
];

styles.oneTimeAddressGridItem = {
    width: 12,
};

styles.shippingAddressOneTimeAddress = {
    formFields: {
        container: {
            css: css`
                ${order.map(item => {
                    return `div > div:has(label[data-test-selector="${item.selector}"]) {
                        order: ${item.order};
                    }`;
                })}
            `,
        },
        companyNameGridItem: {
            width: [12, 12, 12, 6, 6],
        },
        address1GridItem: {
            width: [12, 12, 12, 6, 6],
        },
        address2GridItem: {
            width: [12, 12, 12, 6, 6],
        },
        countryGridItem: {
            width: [12, 12, 12, 6, 6],
        },
        cityGridItem: {
            width: [12, 12, 12, 3, 3],
        },
        stateGridItem: {
            width: [12, 12, 12, 3, 3],
        },
        postalCodeGridItem: {
            width: [12, 12, 12, 3, 3],
        },
        phoneGridItem: {
            width: [12, 12, 12, 3, 3],
        },
        faxGridItem: {
            width: [12, 12, 12, 3, 3],
        },
    },
};
